<template>
    <div class="my-form">
        <slot />
    </div>
</template>
